/**
 * Caracteres que o i4Pro aceita em e-mail — espelha o
 * `I4PRO_SAFE_EMAIL_CHARS_PATTERN` do backend (`shared/utils/email.utils.ts`).
 *
 * `+ & ' !` e espaço são recusados. Valida só o conjunto de caracteres: o
 * formato continua com o `z.email()`.
 */
const I4PRO_SAFE_EMAIL_CHARS_PATTERN = /^[A-Za-z0-9._@-]*$/;

export const I4PRO_EMAIL_CHARS_MESSAGE =
  'E-mail inválido. Use apenas letras, números, ponto, hífen e underscore.';

export function hasOnlyI4ProEmailChars(email: string | undefined): boolean {
  return I4PRO_SAFE_EMAIL_CHARS_PATTERN.test((email ?? '').trim());
}
